const API_BASE_URL=process.env.VUE_APP_API_URL;
const BRIDGE_URL=process.env.VUE_APP_API_BRIDGE_URL
const HUB_URL = process.env.VUE_APP_API_HUB_URL

export {API_BASE_URL,BRIDGE_URL,HUB_URL};